import { render } from "./AmountStepper.vue?vue&type=template&id=74a55f3c&scoped=true"
import script from "./AmountStepper.vue?vue&type=script&lang=ts"
export * from "./AmountStepper.vue?vue&type=script&lang=ts"

import "./AmountStepper.vue?vue&type=style&index=0&id=74a55f3c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-74a55f3c"

export default script